

import { Injectable } from '@angular/core';
import { RequestFormService } from 'src/app/home/services/request-form.service';


@Injectable({
  providedIn: 'root',
})
export class RequestEmployeeUtilsService {

  constructor(
    private requestFormService: RequestFormService,
  ){}

   transformFormData(formData: any): any {
        let index = 1;
        const transformed: any = {};
        for (const key in formData) {
        if (formData.hasOwnProperty(key)) {
            transformed[key] = {
            index:index++,
            valor: formData[key],
            corregir: false,
            };
        }
        }
        return transformed;
    }

    formatDate(date: string): string {
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const day = date.substring(6, 8);
        return `${day}-${month}-${year}`;
      }

    // Método para formatear de yyyy-MM-dd la fecha a 'dd-M-yyyy'
   

    formatPesoChileno(event: any): string {
        let input = event.target.value;
        let hasDollar = false;
        if (input.startsWith('$')) {
          hasDollar = true;
          input = input.substring(1);
        }
        input = event.target.value.replace(/[^0-9.]/g, ''); 
        const formattedInput = this.formatCurrency(input);
        const finalInput = hasDollar ? `$${formattedInput}` : formattedInput;
         return finalInput
      }
    
      formatCurrency(value: string): string {
        value = value.replace(/\./g, '');
        let str = value.toString();
        let resultado = "";
        for (let i = 0; i < str.length; i++) {
              resultado += str[i];
          if ((str.length - i - 1) % 3 === 0 && i < str.length - 1) {
            resultado += ".";
          }
        }  
        return resultado;
      }

      async getAmountRequestUtils(keyForm:string, id_beneficio:number){
        const dataAmount = await this.requestFormService.montoSolicitudFormulario(keyForm, id_beneficio);
        const consumedQuota = dataAmount.esta_consumido;
        const availableAmount = dataAmount.monto_maximo_permitido - dataAmount.monto_consumido;
        const maxAmount = dataAmount.monto_maximo_permitido
        const amountConsumed = dataAmount.monto_consumido
        return {availableAmount, consumedQuota, maxAmount, amountConsumed} 
      }

      public parseMontoNumber(value: number | string | null | undefined): number {
        if (value === null || value === undefined) return 0;
        if (typeof value === 'number') return value;

        const cleaned = value.toString().replace(/\./g, '').trim();
        const parsed = parseInt(cleaned, 10);

        return Number.isNaN(parsed) ? 0 : parsed;
      }

      validacion_montoConsumido(monto_solicitado: string,availableAmount: number | string) {
        if (monto_solicitado === '') {
          return true;
        }

        const montoSolicitadoNum = this.parseMontoNumber(monto_solicitado);
        const availableAmountNum = this.parseMontoNumber(availableAmount);

        return montoSolicitadoNum <= availableAmountNum ? true : false;
      }

      soloNumerosMontos(event: KeyboardEvent) {
        const key = event.key;
        const regex = /^[0-9]$/;
      
        if (!regex.test(key) || key === '.' || key.toLowerCase() === 'e') {
          event.preventDefault();
        }
      }
}
